import { Button, ButtonProps } from '@fluentui/react-components';
import { FullScreenMaximize20Regular, FullScreenMinimize20Regular } from '@fluentui/react-icons';
import React, { useEffect } from 'react';

export default function AppToggleFullscreenButton(props: ButtonProps): JSX.Element {
  const [isFullscreen, setIsFullscreen] = React.useState(document.fullscreenElement !== null);

  useEffect(() => {
    function onFullscreenChange() {
      setIsFullscreen(() => document.fullscreenElement !== null);
    }
    document.addEventListener('fullscreenchange', onFullscreenChange);

    return () => document.removeEventListener('fullscreenchange', onFullscreenChange);
  });

  return (
    <Button
      {...props}
      onClick={() => {
        if (isFullscreen) {
          document.exitFullscreen();
        } else {
          document.body.requestFullscreen();
        }
      }}
    >
      {isFullscreen ? <FullScreenMinimize20Regular /> : <FullScreenMaximize20Regular />}
    </Button>
  );
}
